import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Toast } from "../../../../config/Toast";
import Modal from "../../../../components/Modal";
import InputForm from "../../../../components/InputForm";
import SalaryService from "../../../../services/SalaryCalculation";
import "react-toastify/dist/ReactToastify.css";

const EditSalaryModal = (props) => {
  const data = props.dataModal;

  const [orderSukses, setOrderSukses] = useState(data.orderSukses ? data.orderSukses : 0);
  const [dailySalary, setDailySalary] = useState(data.upahHarian ? data.upahHarian : 0);
  const [insentifSalary, setInsentifSalary] = useState(data.upahInsentif ? data.upahInsentif : 0);
  const [transportSalary, setTransportSalary] = useState(data.upahTransport ? data.upahTransport : 0);
  const [keramikSalary, setKeramikSalary] = useState(data.upahKeramik ? data.upahKeramik : 0);
  const [lasSalary, setLasSalary] = useState(data.upahLas ? data.upahLas : 0);
  const [buildingSalary, setBuildingSalary] = useState(data.feeBuilding ? data.feeBuilding : 0);
  const [total, setTotal] = useState(data.totalUpah ? data.totalUpah : 0);
  const [note, setNote] = useState(data?.notes || null);

  const notifySuccess = (message) => toast.success(message, Toast);
  const notifyFailed = (message) => toast.error(message, Toast);

  const activeModal = props.activeModal ? "effect-scale show" : "";
  const activeStyle = activeModal ? { display: "block", paddingright: "17px" } : "";

  useEffect(() => {
    const newTotal =
      +dailySalary + +insentifSalary + +transportSalary + +keramikSalary + +lasSalary + +buildingSalary;

    setTotal(+newTotal);
  }, [dailySalary, insentifSalary, transportSalary, keramikSalary, lasSalary, buildingSalary]);

  const submitHandler = (e) => {
    const id = data.id;
    const payload = {
      order_sukses: orderSukses,
      upah_harian: dailySalary,
      upah_insentif: insentifSalary,
      upah_transport: transportSalary,
      upah_keramik: keramikSalary,
      upah_las: lasSalary,
      upah_fee_building: buildingSalary,
      total_upah: total,
      keterangan: note,
    };

    SalaryService.edit(id, payload)
      .then(() => {
        notifySuccess(`Upah berhasil diperbarui`);
        props.setUpdate(true);
        props.closeModal();
      })
      .catch((err) => {
        console.log(err);
        notifyFailed(`Upah gagal diperbarui`);
      });
  };

  const formatToIDR = (value) => {
    if (value == null || value === "") return "";
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    }).format(value);
  };

  const parseIDR = (formattedValue) => {
    if (!formattedValue) return 0;
    return Number(formattedValue.replace(/[^0-9]/g, ""));
  };

  const forms = [
    {
      margin: "mb-2",
      label: "Order Sukses",
      type: "text",
      id: "orderSukses",
      value: formatToIDR(orderSukses),
      changeHandler: (val) => setOrderSukses(parseIDR(val)),
    },
    {
      margin: "mb-2",
      label: "Upah Harian",
      type: "text",
      id: "dailySalary",
      value: formatToIDR(dailySalary),
      changeHandler: (val) => setDailySalary(parseIDR(val)),
    },
    {
      margin: "mb-2",
      label: "Insentif",
      type: "text",
      id: "insentifSalary",
      value: formatToIDR(insentifSalary),
      changeHandler: (val) => setInsentifSalary(parseIDR(val)),
    },
    {
      margin: "mb-2",
      label: "Transport",
      type: "text",
      id: "transportSalary",
      value: formatToIDR(transportSalary),
      changeHandler: (val) => setTransportSalary(parseIDR(val)),
    },
    {
      margin: "mb-2",
      label: "Keramik",
      type: "text",
      id: "keramikSalary",
      value: formatToIDR(keramikSalary),
      changeHandler: (val) => setKeramikSalary(parseIDR(val)),
    },
    {
      margin: "mb-2",
      label: "Las",
      type: "text",
      id: "lasSalary",
      value: formatToIDR(lasSalary),
      changeHandler: (val) => setLasSalary(parseIDR(val)),
    },
    {
      margin: "mb-2",
      label: "Bangunan",
      type: "text",
      id: "buildingSalary",
      value: formatToIDR(buildingSalary),
      changeHandler: (val) => setBuildingSalary(parseIDR(val)),
    },
    {
      margin: "mb-2",
      label: "Total",
      type: "text",
      id: "total",
      value: formatToIDR(total),
      changeHandler: (e) => setTotal(parseIDR(e.target.value)),
      disabled: true,
    },
    {
      margin: "mb-2",
      label: "Keterangan",
      type: "text",
      id: "note",
      value: note,
      changeHandler: setNote,
    },
  ];

  return (
    <Modal
      activeModal={activeModal}
      activeStyle={activeStyle}
      title={`ID Project: #${data.projectId}`}
      closeClick={props.closeModal}
      submitHandler={submitHandler}
      type="Update"
      modalType="modal-lg"
    >
      {forms.map((form) => (
        <InputForm key={form.id} {...form} />
      ))}
    </Modal>
  );
};

export default EditSalaryModal;
